import { render } from "./index.vue?vue&type=template&id=2ce7bacc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2ce7bacc&lang=less&scoped=true"

import exportComponent from "E:\\devops.aliyun\\fengtaitiyu\\smart-sports-bigdata-screen\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce7bacc"]])

export default __exports__